import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import $ from 'jquery';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Pagination from "react-js-pagination";
import Autocomplete , { createFilterOptions }  from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
class ManageGroups extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
            users: [],
            group_users: [],
            search: '',
            permissions: [],
            hr_permission: '',
            department: 'all',
            group_type_change:'',
            message: '',
            activePage: 1,
            item_count: '',
            isLoadMore: 1,
            activePage: 1,
            loading: 1,
            empId: '',
            emp_detail: [],
            startDate: moment(),
            endDate: moment(),
            credit_reward_date: moment(),
            fields: {},
            errors: {},
            registered_mail: '',
            first_half_checked: 0,
            second_half_checked: 0,
            group_name: '',
            roles: {},
            get_group_type:[],
            group_type:'1',
            member_email: [],
            pod:[],
            group_info:'',
            editstate:'',
            group_sucsess:'',
            group_mail:'',
            member_emailgroup:[],
            primary_email:[],
            listener_email:[],
            selected_pods:[]
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.searchChange = this.searchChange.bind(this);
        this.departmentChange = this.departmentChange.bind(this);
        this.onPrimaryemail = this.onPrimaryemail.bind(this);
        this.onListeneremail = this.onListeneremail.bind(this);
        this.onPODChange = this.onPODChange.bind(this);
        this.typeChange=this.typeChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    groupChange(propertyName, event,type) {
        var group_type_name = document.getElementById('group_type_name').value;
        group_type_name=group_type_name?group_type_name:type;
        document.getElementById("podname").style.display = group_type_name == 3 ? 'block' : 'none';
        document.getElementById("membergroup").style.display = group_type_name == 3 || group_type_name == 5 ? 'none' : 'block';
        document.getElementById("emailgroup").style.display = group_type_name == 5 ? 'block' : 'none';
        if(this.state.editstate){
            const group_info = this.state.group_info;
            group_info[propertyName] = event.target.value;
            this.setState({ group_info: group_info });
        }else{
        let fields = this.state.fields;
        this.setState({ [event.target.name]: event.target.value });
        fields[event.target.name] = event.target.value;
        }    
    }

    searchChange(event) {
       var obj = this;
       this.setState({ search: event.target.value, activePage: 1 });
        if (this.timer) {
            window.clearTimeout(this.timer);
    }
        this.timer = window.setTimeout(function () {
            obj.userList();
        }, 500);
    }
    departmentChange(event) {
        this.setState({ department: event.target.value }, function () {
            this.userList();
        });
    }
    typeChange(event) {
        this.setState({ group_type_change: event.target.value }, function () {
            this.userList();
        });
    }
    handleValidation() {
        let fields = this.state.editstate?this.state.group_info:this.state.fields;
        let errors = {};
        let formIsValid = true;
        if (!fields["name"] || fields["name"].trim() == "") {
            formIsValid = false;
            errors["groupname"] = "This field is required.";
        }
        if (!fields["email"] || fields["email"].trim() == "") {
            formIsValid = false;
            errors["groupemail"] = "This field is required.";
        }
        if (fields["email"] && !this.isValidEmailAddress(fields["email"])) {
            formIsValid = false;
            errors["groupemail"] = "Please Provide Correct Email.";
        }
        if (fields["email"]) {
            var str = fields["email"];
            var strvalue = str.toLowerCase();
            var res = strvalue.match('@muvi.com');
            if (!res) {
                formIsValid = false;
                errors["groupemail"] = "Please enter a valid domain name. The domain name should be muvi.com";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    isValidNumber(number) {
        var pattern = /^[0-9]+$/;
        return pattern.test(number);
    }
    isValidEmailAddress(emailAddress) {
        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return pattern.test(emailAddress);
    }
    addGroup() {
        if (this.handleValidation()) {
            console.log("Data Has been submitted");
            //return true;
        } else {
            console.log("This Fields Are required.")
            return false;
        }
        document.getElementById("addgroup").innerHTML = "Sending....";
        document.getElementById("addgroup").disabled = true;
        const fd = new FormData;
        fd.append('group_type', JSON.stringify(this.state.group_type));
        fd.append('name', JSON.stringify(this.state.name));
        fd.append('description', JSON.stringify(this.state.description));
        fd.append('email', JSON.stringify(this.state.email));
 		fd.append('primary_email', JSON.stringify(this.state.primary_email));
        fd.append('listener_email', JSON.stringify(this.state.listener_email));
        fd.append('selected_pods', JSON.stringify(this.state.selected_pods));
        let api_url = this.state.apiUrl + '/HrmanagementRest/AddGroup/userAuthKey/' + this.state.userAuthKey;
        if(this.state.editstate){
            api_url = this.state.apiUrl + '/HrmanagementRest/updateGroup/userAuthKey/' + this.state.userAuthKey;
        fd.append('group_inputs', JSON.stringify(this.state));
        }
        fetch(api_url, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                if (responseJson.code == 500) {
                    this.setState({ group_mail: responseJson.msg,group_sucsess:'' })
                    document.getElementById("addgroup").innerHTML = "Sending";
                    document.getElementById("addgroup").disabled = false;
                }
                else if (responseJson.code == 200) {
                    this.setState({ group_sucsess: responseJson.msg,group_mail:''})
                    window.location.href = '/manageGroups';
                }
            })
    }
    back() {
        window.location.href = '/employees/';
    }
    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber });
            fetch(this.state.apiUrl + '/HrmanagementRest/GetGroups/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        users: findresponse.users,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count
                    })
                })
        }
    }
    userList(page = 1) {
        fetch(this.state.apiUrl + '/HrmanagementRest/GetGroups/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                //console.log(findresponse.users)
                this.setState({
                    users: findresponse.users,
                    permissions: findresponse.permissions,
                    hr_permission: findresponse.hr_permission,
                    item_count: findresponse.item_count,
                    loading: 0,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    config:findresponse.config
                })
            })
    }
    delete_group(id, email) {
        if (window.confirm('Do you want to delete ' + email + '?')) {
            fetch(this.state.apiUrl + '/HrmanagementRest/DeleteGroup/id/' + id + '/email/' + email + '/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    if (findresponse.code == 500) {
                        {/*this.setState({ group_mail: findresponse.msg })*/ }
                        alert(findresponse.msg);
                    }
                    else if (findresponse.code == 200) {
                        window.location.href = '/manageGroups';
                    }

                })
        }
    }
    onPrimaryemail = (selectedList) => {
        //var selected=selectedList.map(element=>element.email);
                this.setState({
            primary_email: selectedList,
         }, function () {
            //console.log(this.state.primary_email);
		});
    }
    onListeneremail = (selectedList) => {
		//const selected=listener_email.map(element=>element.email);
		this.setState({
			listener_email: selectedList
		});
    }
    onPODChange = (selectedList) => {
        //let fields = this.state.fields;
        this.setState({ selected_pods: selectedList });    
    }
    editGroupType(id,email){
        this.setState({ editstate: id,group_mail:'' });
        fetch(this.state.apiUrl + '/HrmanagementRest/editGroup/userAuthKey/' + this.state.userAuthKey+'/id/' + id+'/email/' + email , {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                var list_member = findresponse.group_info['group_type'];
                if (findresponse.primary_email) {
                    var monitorList = [];
                    if (findresponse.primary_email) {
                        var monitorCount = 0;
                        var assigneList = list_member==5?this.state.member_emailgroup:this.state.member_email;
                        assigneList.forEach(element => {
                            findresponse.primary_email.forEach(element1 => {
                                if (element.email === element1) {
                                    monitorList[monitorCount++] = element;
                                }
                            });
                        });
                    }
                }
                if (findresponse.listener_email) {
                    var listenerList = [];
                    if (findresponse.listener_email) {
                        var listenerCount = 0;
                        var assigneList = this.state.member_email;
                        assigneList.forEach(element => {
                            findresponse.listener_email.forEach(element1 => {
                                if (element.email === element1) {
                                    listenerList[listenerCount++] = element;
                                }
                            });
                        });
                    }
                }
                if (findresponse.selected_pods) {
                    var podList = [];
                    if (findresponse.listener_email) {
                        var podCount = 0;
                        var assigneList = this.state.pod;
                        assigneList.forEach(element => {
                            findresponse.selected_pods.forEach(element1 => {
                                if (element.name === element1) {
                                    podList[podCount++] = element;
                                }
                            });
                        });
                    }
                }
                //console.log(findresponse.selected_pods);
            {/*if (findresponse.listener_email) {
                var assign_listner = findresponse.listener_email;
                var assignee_list = Object.values(this.state.member_email);
                var assigneeResult_list = assignee_list.find(item => item.email === assign_listner);
            }*/}
               this.setState({
                    group_info: findresponse.group_info,
                    primary_email:monitorList,
                    listener_email:listenerList,
                    selected_pods:podList,
                })
                this.groupChange('','',findresponse.group_info.group_type);
            })
    }
    GetGroupType() {
        //console.log(this.state.editstate);
        document.getElementById('email').value='';
        document.getElementById('name').value='';
        document.getElementById('description').value='';
        document.getElementById('group_type_name').value='1';
        this.setState({
            editstate: '',group_info:'',group_mail:'',primary_email:[],listener_email:[],selected_pods:[]
        })
        fetch(this.state.apiUrl + '/HrmanagementRest/getAddgroup/userAuthKey/' + this.state.userAuthKey , {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
               // console.log(findresponse.group_type)
               this.setState({
                    get_group_type: findresponse.group_type,
                    member_email: findresponse.member_email,
                    member_emailgroup:findresponse.member_emailgroup,
                    pod: findresponse.pod,
                })
            })
    }
    getUserRows() {
        if (this.state.loading) {
            return (
                <div class="loader-new"></div>
            )
        } else {
            return (
                <div class="list_check">
                    <div> <div class="tickets hidden-sm">
                        <ul class="tickets_head">
                            <li class="intra_col_30">Group Name</li>
                            <li class="intra_col_15">Group Type</li>
                            <li class="intra_col_45">Description</li>
                            <li class="intra_col_5">{this.state.hr_permission == 'yes' ? 'Action' : ''}</li>
                        </ul>
                        {
                            this.state.users.map((user, key) =>
                                <ul class="tickets_number">
                                    <li class="intra_col_30">
                                        <div class="emps_details">
                                            <div class="emps_pic">{user.attachment ? <img src={user.attachment_url + user.attachment} /> : <span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span>}</div>
                                           <Link key={key} to={`/viewGroups/${user.email}`} name={"max"}>{user.name}</Link>
                                        </div>
                                    </li>
                                   <li class="intra_col_15">{this.state.config['grouptype'][user.group_type]?this.state.config['grouptype'][user.group_type]:'--'}</li>
                                    <li class="intra_col_45">
                                        <div>{user.description?user.description:'--'}</div>
                                    </li>
                                   {this.state.hr_permission == 'yes' ? <li class="intra_col_5 text-left">
                                        <a href="javascript:void(0);" onClick={() => this.editGroupType(user.id, user.email)}><i class="far fa-edit" data-toggle="modal" data-target="#Modalgroups"></i></a>&nbsp;&nbsp;
                                        <a href="javascript:void(0);" onClick={() => this.delete_group(user.id, user.email)}><i class="fas fa-trash"></i></a>
                                    </li> : ''}
                                </ul>

                            )
                        }
                    </div>
                        {
                            this.state.users.map((user, key) =>
                                <div class="customer_mob hidden-md">
                                    <div class="custmer_list_mob emp_mob">
                                        <div class="emps_pic">{user.attachment ? <img src={user.attachment_url + user.attachment} /> : <span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span>}</div>
                                        <Link key={key} to={`/viewGroups/${user.email}`} name={"max"}>
                                            <h4 class="list_title">{user.name}</h4>
                                        </Link>
                                    </div>
                                </div>)} </div>
                    {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                </div>
            )
        }
    }
    componentDidMount() {
        document.title = "Intranet | Groups";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.userList();
        this.GetGroupType();
        $('.searchTicket.dept').on('click', function () {
            $(this).closest('.intranet_body').find('.filter_dept').slideToggle('slow');
        });
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        const filterOptions = createFilterOptions({
            matchFrom: 'start',
            stringify: option => option.name,
          });
        return (
            <div class="group">
                <Header brecum_name="Groups" brecum_page="Groups" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <span>Groups</span>
                        </div>
                        <div class="top-row">
                            <div class="left-section pull-left">
                                {this.state.hr_permission == 'yes' ?
                                    <div><span class="hidden-sm"><a onClick={() => this.GetGroupType()} class="btn btn-sky mob" href="javascript:void(0);" data-toggle="modal" data-target="#Modalgroups">Add Groups</a></span>
                                    </div> : ''}
                            </div>
                            <div class="right-section pull-right">
                                <div class="row">
                                    <div class="col-md-7 col-xs-12 pull-right">
                                        <div class="searchTicket emp_dept wid_100">
                                            <input type="text" class="form-control" name="search" id="search" placeholder="Search Group by name or email" onChange={this.searchChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-xs-12">
                                    <label for="staticEmail" class="col-sm-3 col-form-label"></label>
                                    <div className="form-group col-sm-9">
                                    <select class="form-control" id="group_type_change" name="group_type_change" onChange={this.typeChange}>
                                    <option value=''>All</option>
                                    {
                                        this.state.get_group_type.map((dynamicData, key) =>
                                            <option value={dynamicData.key} >{dynamicData.value}</option>
                                        )
                                    }
                                 </select>
                                 </div>
                                 </div>

                                    {/* <--modal start for reminder-!> */}
                                    <div class="modal fade" id="Modalgroups" role="dialog">
                                        <div class=" modal-dialog modal-md">
                                            <div class="modal-content">

                                                <div class="modal-header">
                                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                                    <h4 class="modal-title">{this.state.editstate?'Edit Group':'Add Group'}</h4>
                                                </div>

                                        <div class="col-xs-12">
                                                <div class="buttom_pod"></div>
                                                <div class="col-xs-12">
                                                <label for="staticEmail" class="col-sm-3 col-form-label">Type</label>
                                                <div className="form-group col-sm-9">
                                                <select class="form-control" id="group_type_name" name="group_type" value={this.state.group_info.group_type} onChange={this.groupChange.bind(this, 'group_type')}>
                                                {
                                                    this.state.get_group_type.map((dynamicData, key) =>
                                                        <option value={dynamicData.key} >{dynamicData.value}</option>
                                                    )
                                                }
                                             </select>
                                             </div>
                                             </div>
                                             <div class="col-xs-12">
                                                <label for="staticEmail" class="col-sm-3 col-form-label">Name</label>
                                                <div className="form-group col-sm-9">
                                                <input type="text" class="form-control" name="name" id="name" value={this.state.group_info.name} onChange={this.groupChange.bind(this, 'name')} />
                                                    <span class="error">{this.state.errors["groupname"]}</span>
                                             </div>
                                             </div>
                                             <div class="col-xs-12">
                                             <label for="staticEmail" class="col-sm-3 col-form-label">Description</label>
                                             <div className="form-group col-sm-9">
                                             <textarea class="form-control" name="description" id="description" value={this.state.group_info.description} onChange={this.groupChange.bind(this, 'description')}></textarea>    
                                          </div>
                                          </div>
                                          <div class="col-xs-12">
                                          <div class="margin_top">
                                             <label for="staticEmail" class="col-sm-3 col-form-label">Email</label>
                                             <div className="form-group col-sm-9">
                                             <input type="text" class="form-control" name="email" id="email"  value={this.state.group_info.email} onChange={this.groupChange.bind(this, 'email')} />
                                                    <span class="error">{this.state.errors["groupemail"]}</span>
                                                    </div>
                                                </div>
                                          </div>
                                          <div id="membergroup">
                                          <div class="col-xs-12">
                                             <label for="staticEmail" class="col-sm-3 col-form-label">Primary Members</label>
                                             <div className="form-group col-sm-9">
                                            <div>
                                            <Autocomplete
                                                    multiple
                                            id="tags-outlined"
                                            className="autocomplete"
                                            options={this.state.member_email}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(event , value) => this.onPrimaryemail(value)}
                                                    value={this.state.primary_email}
                                            filterOptions={filterOptions} 
                                            filterSelectedOptions
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    //label="Users Names"
                                                    placeholder="Select"
                                                />
                                                )}
                                        />
                                          </div>
                                          </div>
                                          </div>

                                          <div class="col-xs-12">
                                             <label for="staticEmail" class="col-sm-3 col-form-label">Listener Members</label>
                                             <div className="form-group col-sm-9">
                                        <div>
                                                <Autocomplete
                                                 multiple
                                                id="tags-outlined"
                                                className="autocomplete"
                                                options={this.state.member_email}
                                                getOptionLabel={(option) => option.name}
                                                onChange={(event , value) => this.onListeneremail(value)}
                                                 value={this.state.listener_email}
                                                filterOptions={filterOptions} 
                                                filterSelectedOptions
                                                renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    //label="Users Names"
                                                    placeholder="Select"
                                                />
                                                )}
                                            />
                                          </div>
                                          </div>
                                          </div>
                                          
                                          </div>
                                          <div class="col-xs-12" id="podname" >
                                          <label for="staticEmail" class="col-sm-3 col-form-label">Includes</label>
                                          <div className="form-group col-sm-9">
                                          <div>
                                                <Autocomplete
                                        multiple
                                                id="tags-outlined"
                                                className="autocomplete"
                                                options={this.state.pod}
                                                getOptionLabel={(option) => option.name}
                                                onChange={(event , value) => this.onPODChange(value)}
                                        value={this.state.selected_pods}
                                                filterOptions={filterOptions} 
                                                filterSelectedOptions
                                                renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    //label="Users Names"
                                                    placeholder="Select"
                                                />
                                                )}
                                            />
                                       </div>
                                       </div>
                                    </div>
                                    </div>
                                    <div id="emailgroup">
                                    <div class="col-xs-12">
                                    <label for="staticEmail" class="col-sm-3 col-form-label">Members</label>
                                    <div className="form-group col-sm-9">
                                    <div>
                                           <Autocomplete
                                           multiple
                                           id="tags-outlined"
                                           className="autocomplete"
                                           options={this.state.member_emailgroup}
                                           getOptionLabel={(option) => option.name}
                                           onChange={(event , value) => this.onPrimaryemail(value)}
                                           value={this.state.primary_email}
                                           filterOptions={filterOptions} 
                                           filterSelectedOptions
                                           renderInput={(params) => (
                                               <TextField
                                                   {...params}
                                                   variant="outlined"
                                                   //label="Users Names"
                                                   placeholder="Select"
                                               />
                                               )}
                                       />
                                 </div>
                                 </div>
                                    </div>        
                                    </div>        
                                    <span class="faid_message">{this.state.group_mail}</span>
                                    <span class="success_message">{this.state.group_sucsess}</span>
                                                <div class="modal-footer">
                                                    <button type="button" class="btn btn-sky" id="addgroup" onClick={() => this.addGroup()}>Save</button>
                                                    <button type="button" class="btn btn-blue" data-dismiss="modal">No</button>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    {/* <--modal start-!> */}
                                </div>
                            </div>

                        </div>
                        {this.getUserRows()}
                    </div>
                </div>

            </div>
        );
    }
}
export default ManageGroups;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/manageGroups.js